module.exports = __webpack_public_path__ + "grigio.jpg?eabd594ec36c8d402526ceeaf31295c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grigio.jpg
// module id = 198
// module chunks = 0